import React, { Component,useState } from 'react';
import {siteLink,getSettings,Image} from '../helpers';
//import Navigation from './Navigation';
import {Link,withRouter} from 'react-router-dom';
//import join from 'join-path'
class Header extends Component {
    state = {burger: false,url:null};
    componentWillReceiveProps (a, b){
        // this function will close mobile menu when selected
        this.toggleMenu("url");
    }
    toggleMenu = (action) => {
        // this function will avoid mobile menu to open when url change
        let burger = !this.state.burger;
            burger = (action ==="url")? false : burger;
            this.setState({
                burger,
                url:this.props.match.url
            });
  
    };
    filterNav = (arr) => {
        let newArray = [];
        arr.map((a, i) =>{
            if(a[0] !=="undefined"){
                newArray[i] = [];
                a.map((b, j)=>{
                   if(b !=="undefined"){
                       newArray[i][j] = b;
                   }
                   return null;
                });
            }
            return null;
        });
        
        return newArray;
    }
    render() {  
        const theme = getSettings("theme",this.props.app.settings);
        const logo = Image(theme("logo"));
        const Navigation = (props)=>{
            const [burger, setBurger]  = useState(null);   
            const NavbarItems = [];
            const getPages  = () =>{
                let p = [];
                Object.keys(this.props.app.pages).map((arr,i)=>{
                    p[i] = [];
                    p[i][0] =  arr;
                    return null;
                });
                return p;
            }
            const getPageName = (key) =>{
                if(key === "catalog"){
                    return this.props.app.settings.pages.catalog.name;
                }
                if(typeof this.props.app.pages[key] !=="object"){
                    return key + "null";
                }else{
                    return this.props.app.pages[key].name 
                }
            }
            let navigation  = Array.isArray(this.props.app.navigation)? this.filterNav(this.props.app.navigation) : getPages() ;
                  if(Array.isArray(navigation)){
                     let count =0;
                     let effect  = {animation: `navbar-menu-item .${count}s ease-out`};
                    
                     navigation.map((item, key)=>{
                         count++;
                         let link = item[0];
                             link = link ==="catalog"? this.props.app.settings.pages.catalog.slug : link;
                             effect  = {animation: `navbar-menu-item .${count}s ease-out`};
                          
                         if(item[0].length > 0){
                            // DROPDOWN DPRECATED
                            NavbarItems.push(<Link key={count} style={effect} to={`/${link}`} className="navbar-item no-focus">{getPageName(item[0])}</Link>);
                         }
                         return null;
                     });
                  }
            return  <nav className={`navbar is-black`}>
                        <div className="navbar-brand logo is-tablet">
                            <Link className="navbar-item no-focus is-goback-button" to={siteLink("/")}>
                                <img src={logo} width="112" height="28"/>
                            </Link>
                        </div>
                        <div className="navbar-brand logo is-mobile">
                            <Link className="navbar-item no-focus is-goback-button" to={siteLink("/")}>
                                <img src={logo} width="112" height="28"/>
                            </Link>
                        </div>
                        <div className="navbar-brand">
                            <a onClick={()=> {setBurger(!burger) }} className={`hamburger ${burger? 'is-active':""}`}>
                                <span></span>
                            </a>
                         </div>
                        <div className="center">
                            <div className="navbar-brand logo is-desktop">
                                <Link className="navbar-item no-focus is-goback-button" to={siteLink("/")}>
                                    <img src={logo} width="112" height="28"/>
                                </Link>
                            </div>
                            <div className={`navbar-menu ${burger? "is-active":""}`}>
                                <div className="navbar-start">
                                    {NavbarItems}
                                </div>
                            </div>
                        </div>
                       
                    </nav>
                
        }
       return <Navigation {...this.props}  navBg={theme('navBg')}/>
        
    }
}
export default withRouter(Header);


// WEBPACK FOOTER //
// ./src/components/Header.js